import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { NakedInput } from "./ControlsCommon";
export const _FillByText = ({ className, maxWidth, value, placeholder, children, }) => {
    return (_jsx(Wrapper, { "data-value": value || 0, "data-placeholder": placeholder, "$maxWidth": maxWidth, className: className, children: children }));
};
const ContentStyles = css `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
const Wrapper = styled.div `
  position: relative;
  min-width: 2px;
  display: inline-block;

  max-width: ${(p) => (p.$maxWidth ? p.$maxWidth + "px" : "100%")};

  &:after {
    height: 0;
    display: block;
    max-width: 100%;
    overflow: hidden;
    content: attr(data-value) " ";
    visibility: hidden;
    white-space: nowrap;
  }

  &:before {
    height: 0;
    display: block;
    content: attr(data-placeholder) " ";
    visibility: hidden;
    white-space: nowrap;
  }

  ${NakedInput} {
    ${ContentStyles};
  }
`;
export const FillByText = Object.assign(_FillByText, {
    Wrapper,
    ContentStyles,
});
